import axios from 'axios';
import { isCacheableRequest, getCachedRequest, cacheRequest } from '../utils/requestCache';

const apiClient = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Token ${token}`;
  }

  // Справочники (/shops, /suppliers, /categories) отдаём из кеша без сети
  if (config.method === 'get' && isCacheableRequest(config.url)) {
    const cached = getCachedRequest(config.url);
    if (cached) {
      const adapter = () => Promise.resolve({
        data: cached,
        status: 200,
        statusText: 'OK',
        headers: {},
        config,
        request: {},
        fromCache: true,
      });
      adapter.fromCache = true;
      config.adapter = adapter;
    }
  }
  return config;
});

apiClient.interceptors.response.use((response) => {
  if (
    response.config.method === 'get' &&
    isCacheableRequest(response.config.url) &&
    !response.config.adapter?.fromCache
  ) {
    cacheRequest(response.config.url, response.data);
  }
  return response;
});

export default apiClient;